import React, {useEffect, useRef, useState} from 'react';
import { useInViewport } from 'react-in-viewport';
import Skeleton from 'react-loading-skeleton';
import { config } from '@fortawesome/fontawesome-svg-core'

import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false

import Masonry from '@mui/lab/Masonry';

import Checkers from '../../../../../../helpers/class/Checkers';
import CustomModal from '../../../../../CustomModal';
import FeaturedFeatures from '../../../partials/features/FeaturedFeatures';
import FeatureType from '../../../partials/features/FeatureType';
import ModalPropertyFeatures from '../../../partials/modals/ModalPropertyFeatures';

export default function Features ( props ) {
  const config = { disconnectOnLeave: false };
  const options = {  };
  const myRef = useRef();
  const {
    inViewport
  } = useInViewport(
    myRef,
    options,
    config,
    props
  );
  const [ show, setShow ] = useState( false );
  const handleClose = () => setShow( false );
  const handleShow = () => setShow( true );

  let viewPortResult = null;
  const has_groups = Checkers.objChildExistsAndIsValidArray( props.features, 'groups' ) && Checkers.objChildExistsAndIsValidArray( props.features.groups[0], 'group' );;
  const has_featured_features = Checkers.objChildExistsAndIsValidArray( props.features, 'featured_features' );

  if ( !inViewport ) {
    viewPortResult =
      <div ref={myRef}>
        <Skeleton height={30} className="col-8 col-sm-5 col-md-3 b-rad-md mb-1" />
        <Skeleton height={42} className="col-9 col-sm-7 col-md-5 b-rad-md mb-2"/>
        <Skeleton height={35} className="col-12 b-rad-lg mb-1"/>
        <Skeleton height={30} className="col-8 col-sm-6 col-md-4 b-rad-md mb-2"/>
      </div>
    ;
  } else {
    viewPortResult =
      <div className="col-12">
        <p className="block-title m-t-40 hint-text no-margin">Facilities</p>
        <h2 className="m-t-5">Available facilities and amenities</h2>
        {
          has_featured_features ?
            <>
              <FeaturedFeatures app={props.app} featured_features={props.features.featured_features} feature_group={props.features.groups}/>
              <p>
                <button className="btn-link" onClick={handleShow}>See all the amenities...</button>
              </p>
              {
                has_groups &&
                  <CustomModal
                    modalName={'features_modal'}
                    className="slide_right"
                    modalSize="lg"
                    closeModal={() => {
                      handleClose()
                    }}
                    show={show}
                    Title={<h2 className="text-overflow text-left mt-0">Available facilities and amenities</h2>}
                  >
                    <ModalPropertyFeatures
                      feature_groups={props.features.groups}
                      handleClose={handleClose}
                    />
                  </CustomModal>
              }
            </>
            :
            has_groups &&
              <Masonry className="mt-4" columns={{ xs: 1, sm: 2, md: 3 }} spacing={3}>
                {
                  props.features.groups[0].group.map( ( group ) => (
                    group.features.length > 0 &&
                      <div key={group.group_id.toString()}>
                        <div className="block-title p-b-15 text-black">
                          {group.group_title}
                        </div>
                        {
                          group.features.map( ( feature ) => {
                            return (
                              <FeatureType key={feature.feature_id.toString()} feature={feature}/>
                            )
                          })
                        }
                      </div>
                  ) )
                }
              </Masonry>
        }
      </div>
    ;

  }

  return (
    ( has_featured_features || has_groups ) &&
      <div id="pro_detail_amenities" className="pb-5">
        <div className="row w-100 no-margin">
          { viewPortResult }
        </div>
      </div>
  )
}
